function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 216.79 -41.836)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-585.542 368.223c-1.965-1.073-19.662-18.462-36.073-18.462-8.534 0-15.225 2.574-21.124 4.848-5.985 2.304-11.635 4.48-19.814 4.48-9.532 0-17.445-2.91-24.43-5.476-5.631-2.064-10.495-3.852-15.472-3.852-4.974 0-9.838 1.788-15.47 3.852-6.981 2.566-14.896 5.475-24.427 5.475-8.18 0-13.83-2.175-19.814-4.48-5.9-2.273-12.59-4.847-21.122-4.847-16.416 0-34.114 17.389-36.077 18.461 0 0 7.145-4.47 13.794-4.47 6.65 0 12.409 4.664 22.284 4.664 5.064 0 9.192 1.588 14.421 3.6 6.624 2.554 14.866 5.724 26.515 5.724 12.851 0 23.26-3.821 30.861-6.611 3.46-1.272 7.38-2.713 9.036-2.713 1.662 0 5.58 1.44 9.039 2.713 7.603 2.79 18.01 6.611 30.864 6.611 11.645 0 19.89-3.17 26.514-5.723 5.226-2.013 9.355-3.601 14.423-3.601 9.873 0 17.356-4.664 22.28-4.664 4.926 0 13.875 4.468 13.875 4.468z",
  fill: "#20201e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-639.75 261.539c0-29.43-25.111-76.082-44.33-82.39a19.09 19.09 0 00-2.064-.552c3.352-1.243 5.749-4.458 5.749-8.243a8.794 8.794 0 00-8.793-8.793c-4.855 0-8.798 3.936-8.798 8.793 0 3.375 1.908 6.299 4.696 7.776-3.94.255-8.197 1.28-12.583 3.047-2.797-1.272-5.58-2.183-8.323-2.683a8.792 8.792 0 00-3.321-16.933 8.792 8.792 0 00-8.793 8.793c0 3.43 1.97 6.398 4.836 7.847a21.376 21.376 0 00-4.387.948c-19.175 6.309-43.728 51.234-43.728 82.39 0 24.846 10.067 46.25 21.687 61.744 1.73 4.594 4.36 4.729 4.928 5.297 0 0 .003-.003.005-.003-.011.077-2.303 14.975-2.527 18.34-.346 5.185-.868 11.311-.868 11.311 12.678 5.577 26.57 8.815 41.66 8.815 15.095 0 28.301-3.551 40.975-9.125-.452-4.144-.97-8.286-2.006-14.507-.54-3.254-2.403-14.84-2.403-14.84.565-.562 3.985-4.851 3.985-4.851 12.333-15.573 24.382-36.337 24.382-62.167z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 4.152
}), /*#__PURE__*/React.createElement("path", {
  d: "M-742.658 328.582c10.282-4.43 22.104-8.314 37.423-8.314 15.314 0 27.132 3.88 37.413 8.304.564-.562 1.908-2.003 4.684-5.89-8.65-9.36-21.24-14.504-41.833-14.504-21.974 0-33.969 5.733-42.617 15.107 1.761 4.562 4.404 4.719 4.97 5.285z",
  stroke: "#000",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M-664.068 357.903c-12.68-5.57-25.647-8.332-40.74-8.332-15.091 0-29.219 3.072-41.896 8.643 12.677 5.576 26.568 8.814 41.66 8.814 15.102 0 28.316-3.555 40.994-9.123z",
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 3.189,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-664.415 323.705c7.986-13.346 18.491-38.517 5.363-81.354-11.014-35.941-43.466-71.01-67.071-63.218-20.937 6.913-43.728 56.419-43.728 82.39 0 24.846 10.064 46.25 21.682 61.745l83.78.409z",
  stroke: "#000",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("circle", {
  r: 8.794,
  cy: 170.333,
  cx: -717.772,
  stroke: "#000",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M-668.41 328.55l-.003-.009c-10.282-4.42-22.109-8.126-37.414-8.126-15.317 0-27.128 3.708-37.413 8.135 0 0-2.304 14.972-2.528 18.345-.346 5.186-.867 11.313-.867 11.313 12.675-5.57 26.807-8.643 41.894-8.643 14.802 0 28.242 2.962 40.738 8.332-.45-4.144-.969-8.286-2.004-14.507-.567-3.272-2.423-14.881-2.423-14.881z",
  stroke: "#000",
  strokeWidth: 1.676,
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-668.788 348.622a121.799 121.799 0 00-36.12-5.484c-12.769 0-25.818 2.08-37.523 5.755",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.676,
  strokeLinecap: "round",
  strokeLinejoin: "bevel"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.676,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-739.984 327.197c9.523-3.834 20.442-6.952 34.167-6.952 13.798 0 24.755 3.152 34.314 7.01M-665.296 320.433c-12.088-9.668-21.761-12.258-39.662-12.258-14.993 0-30.464 3.97-37.876 10.759"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeWidth: 1.676,
  d: "M-688.042 249.3h-20.701v-18.688l4.121-4.12-8.305-8.306-8.306 8.305 4.153 4.153V249.3h-20.827l-4.122-4.121-8.305 8.306 8.305 8.305 4.185-4.153h20.764v22.778l-4.153 4.153 8.306 8.306 8.305-8.306-4.121-4.121v-22.81h20.638l4.153 4.153 8.306-8.305-8.306-8.306z"
}));

function SvgBlackBishop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.888 57.747"
  }, props), _ref);
}

export default SvgBlackBishop;